import React, { useState } from 'react';
import './styles.css';
import Icon from '../Icon';

const Carousel = ({ items, renderItem, qntdItems }) => {
  const [startIndex, setStartIndex] = useState(0);

  const slideLeft = () => {
    if (startIndex > 0) {
      setStartIndex(startIndex - 1);
    }
  };

  const slideRight = () => {
    if (startIndex < items.length - qntdItems) {
      setStartIndex(startIndex + 1);
    }
  };

  const visibleItems = items.slice(startIndex, startIndex + qntdItems);

  return (
    <div className="carousel-wrapper">
      <button className="carousel-button" onClick={slideLeft} disabled={startIndex === 0}>
        <Icon name="chevronLeft" size={20} className="icon-spacing" />
      </button>
      <div className="carousel">
        {visibleItems.map((item, index) => (
          <div key={index} className="carousel-item">
            {renderItem(item)}
          </div>
        ))}
      </div>
      <button className="carousel-button" onClick={slideRight} disabled={startIndex >= items.length - qntdItems}>
        <Icon name="chevronRight" size={20} className="icon-spacing" />
      </button>
    </div>
  );
};

export default Carousel;